import React,{useState} from 'react'
import { IdListPageStyle } from './IdListInput.styled'
import { BaseStationSchema, BeaconSchema } from '../../validations/ResellerValidations'
import moment from "moment";
import { useDB } from '../../context/DynamoDBContext';
import { toast } from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner';

const EditInput = ({item,onDelete,index,title=""}) => {
    const {dynamoDBClient}=useDB()
    const [action, setAction] = useState(false)
    const [value, setValue] = useState(item[title])
    const [previousValue, setPreviousValue] = useState(item[title])
    const [valueErr, setValueErr] = useState(false)
    const [valueErrStatement, setValueErrStatement] = useState("")
    const [loading, setLoading] = useState(false)

    const Errors=(err)=>{
        err.forEach((element) => {
        switch(element.split(':')[0]){
            case "3":
                setValueErr(true)
                setValueErrStatement(element.split(':')[1])
            break;
            case "4":
                setValueErr(true)
                setValueErrStatement(element.split(':')[1])
            break;
            case "5":
                setValueErr(true)
                setValueErrStatement(element.split(':')[1])
            break;
            case "6":
                setValueErr(true)
                setValueErrStatement(element.split(':')[1])
            break;
            case "7":
                setValueErr(true)
                setValueErrStatement(element.split(':')[1])
            break;
            case "8":
                setValueErr(true)
                setValueErrStatement(element.split(':')[1])
            break;
            default:
            break;

        }
        })
    }

    const success=(text,check)=>{
        setLoading(false)
        if(check){

            toast(`${text} updated successfully`)
        }else{
            toast.error(`Unable to update ${text}`,{
                bodyClassName:"notification-div-error",
                progressClassName:"progress-bar-error"
            })
            setValue(previousValue)
        }
        setAction(false)
        setValueErr(false)
        setValueErrStatement("")
    }

    const updateBeacon=async()=>{
        try {
            setLoading(true)
            var params={
                TableName:"Resellers",
                Key:{"Id":item.Id,"ResellerID":item.ResellerID},
                UpdateExpression: "SET BeaconMAC = :newVal, DateUpdated = :newVal2",
                ExpressionAttributeValues:{
                    ":newVal":value,
                    ":newVal2":`${moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSS')}`
                },
                ReturnValues: "ALL_NEW", 
            }

            const result= await dynamoDBClient.update(params).promise()
            success("BeaconMAC",true)
        } catch (error) {
            success("BeaconMAC",false)
        }
        
    }

    const updateGateway=async()=>{
        try {
            setLoading(true)
            var params={
                TableName:"Resellers",
                Key:{"Id":item.Id,"ResellerID":item.ResellerID},
                UpdateExpression: "SET GatewayMAC = :newVal, DateUpdated = :newVal2",
                ExpressionAttributeValues:{
                    ":newVal":value,
                    ":newVal2":`${moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSS')}`
                },
                ReturnValues: "ALL_NEW", 
            }

            const result= await dynamoDBClient.update(params).promise()
            success("GatewayMAC",true)
            
        } catch (error) {
            success("GatewayMAC",false)
        }
    }

    const update=async()=>{
        const formData={
            id:value
        };
        if(title==="GatewayMAC"){
            await BaseStationSchema.validate(formData,{
                abortEarly:false
            }).then((value)=>{
                updateGateway()
            }).catch((err)=>{
                Errors(err.errors)
            })
        }else if(title==="BeaconMAC"){
            await BeaconSchema.validate(formData,{
                abortEarly:false
            }).then((value)=>{
                updateBeacon()
            }).catch((err)=>{
                Errors(err.errors)
            })
        }
        
    }

  return (
    <IdListPageStyle>
      
        <div key={index} className='input-div'>
            

                <input 
                    className="form-control input-field2" 
                    value={value}
                    onChange={(e)=>{
                        const string=e.target.value.toLocaleUpperCase()
                        setValue(string)
                        setValueErr(false)
                        setValueErrStatement("")
                    }}
                    disabled={!action || loading}
                    maxLength={12}
                />
                
            
            {
                action?
                    <>
                        {loading ?
                            <div className='spinner-div'>
                                <Spinner animation='border' size='sm' variant='secondary' />
                            </div>
                            
                            :
                            <>
                                <div className='action-div'><i className="bi bi-check2" onClick={()=>update()}  /></div>
                                <div className='action-div2'><i className="bi bi-x" onClick={()=>setAction(false)} /></div>
                            </>
                        }
                        
                    </>
                :
                    <>
                        <i 
                            title='Edit' 
                            className={"bi bi-pencil edit-icon"}
                            onClick={()=>{
                                setAction(true)                 
                            }} 
                        />
                        <i className="bi bi-dash-circle remove-icon" onClick={() => onDelete(item)} title='Remove'/>
                    </>
            }
            
        </div>
        {valueErr && <p className='text-error'>{valueErrStatement}</p>}
    </IdListPageStyle>
  )
}

export default EditInput